export class IHolidays {
    providerHolidayId: number;
    providerHolidayName: string;
    providerHolidayDesc: string;
    pHolidayDate: Date;
    clinicHolidayId: number;
    clinicHolidayName: string;
    clinicHolidayDesc: string;
    providerId: string;
    holidayDate: Date;
    holidaydate: string;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
    dbOperation: string;
    checkFlag: boolean;
    facilityId: number;
    locationId: number;
    locationName: string;
    isFulDay: boolean;
}

export class IIntervention {
    interventionId: number;
    planned: string;
    status: string;
    date: Date;
    stringdate: string;
    type: string;
    dbOperation: string;
    encounterId: string;
    createdOn: Date;
    procedureId: string;
    assigningAuthority: string;
    scopingEntity: string;
    negation?: string;
    reason?: string;
    negotionType: string;
    HCPCSCode: string;
    HCPCSName: string;
    T_Icd?: string;
    T_Cpt?: string;
    T_Hcpcs?: string;
    IsType?: string;
}

export class IInpatient {
    encounterId: string;
    Diagnosis?: string;
    Dischargedisposition?: string;
    Facility?: string;
    LengthOfStay?: string;
    Id?: number;
}
